import request from '@/utils/$x';

export async function getCosBucket(params) {
  return request.post('/tencent/cosBucket', params);
}

/**
 * 获取通用枚举值
 * @param {*} serviceName
 * @param {*} params
 * @returns
 */
export async function queryEnumSelect(serviceName, params) {
  return request.post(`/common/queryEnumSelect/${serviceName}`, params);
}
